"use client";

import { c as _c } from "react/compiler-runtime";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "./snap-rail.css";

/** A shelf's controls (useSnapRail): the arrows, and a dot for each place the track can rest. */
export default function SnapRailNav(t0) {
  const $ = _c(33);
  const {
    stops,
    index,
    go,
    labels,
    isFa,
    groupLabel
  } = t0;
  if (stops < 2) {
    return null;
  }
  const Prev = isFa ? ChevronRight : ChevronLeft;
  const Next = isFa ? ChevronLeft : ChevronRight;
  let t1;
  if ($[0] !== go || $[1] !== index) {
    t1 = () => go(index - 1);
    $[0] = go;
    $[1] = index;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = isFa ? "\u0642\u0628\u0644\u06CC" : "Previous";
  let t3;
  if ($[3] !== Prev) {
    t3 = <Prev aria-hidden={true} />;
    $[3] = Prev;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t4 = <button type="button" className="v2-rail-arrow v2-focus" onClick={t1} aria-label={t2}>{t3}</button>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== go || $[10] !== index || $[11] !== labels || $[12] !== stops) {
    let t6;
    if ($[14] !== go || $[15] !== index) {
      t6 = (label, i) => <button key={i} type="button" className="v2-rail-dot v2-focus" aria-pressed={i === index} aria-label={label} onClick={() => go(i)} />;
      $[14] = go;
      $[15] = index;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    t5 = labels.slice(0, stops).map(t6);
    $[9] = go;
    $[10] = index;
    $[11] = labels;
    $[12] = stops;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[17] !== groupLabel || $[18] !== t5) {
    t6 = <div className="v2-rail-dots" role="group" aria-label={groupLabel}>{t5}</div>;
    $[17] = groupLabel;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== go || $[21] !== index) {
    t7 = () => go(index + 1);
    $[20] = go;
    $[21] = index;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  const t8 = isFa ? "\u0628\u0639\u062F\u06CC" : "Next";
  let t9;
  if ($[23] !== Next) {
    t9 = <Next aria-hidden={true} />;
    $[23] = Next;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t7 || $[26] !== t8 || $[27] !== t9) {
    t10 = <button type="button" className="v2-rail-arrow v2-focus" onClick={t7} aria-label={t8}>{t9}</button>;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t10 || $[30] !== t4 || $[31] !== t6) {
    t11 = <div className="v2-rail-nav">{t4}{t6}{t10}</div>;
    $[29] = t10;
    $[30] = t4;
    $[31] = t6;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  return t11;
}